module.exports = __webpack_public_path__ + "static/media/test-kit.dbf29554.svg";